import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 219B8956-E48B-4D11-9257-422E563955DB
 * name checkbox-blank-badge-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-blank-badge-outline.svg
 * tags
 * - Notification 
 * - Form 
 */
export const CheckboxBlankBadgeOutlineIcon = createSvgIcon(<><path d="M23 4.5C23 6.43 21.43 8 19.5 8S16 6.43 16 4.5 17.57 1 19.5 1 23 2.57 23 4.5M19.5 10C19.33 10 19.17 10 19 10V19H5V5H14.03C14 4.84 14 4.67 14 4.5C14 4 14.08 3.5 14.21 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V9.79C20.5 9.92 20 10 19.5 10Z" /></>, 'CheckboxBlankBadgeOutlineIcon');
export default CheckboxBlankBadgeOutlineIcon